import cn from 'classnames';
import moment from 'moment';
import { get } from 'lodash-es';
import { checkIsNull } from '../../Utils/utils';

const CSS_UID = 'field-date-24qsdfssfg4-00f8-4e7b-8825-456qsdf465qs';
const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

/**
 *  add class name
 * @param {*} param0
 */
export const addClassName = ({ existError, showError }) =>
  cn(CSS_UID, {
    exist_error_style: existError,
    show_error_style: showError,
    valid_style: !existError && !showError,
  });

export const getCorrectDate = date => {
  try {
    const momentObject = moment(date);
    if (get(momentObject, '_isValid') && !checkIsNull(date)) {
      return momentObject.format(DEFAULT_DATE_FORMAT);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getCorrectDate: ${e}`);
  }
  return undefined;
};
